export default "__VITE_ASSET__d827b634__"